// Local override: add article.url_link from home articles endpoint
// @ts-nocheck

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

interface IResponse {
  id: string;
  title: string;
  articles: {
    id: number;
    title: string;
    url_link?: string;
    background_picture?: string;
  }[];
}

const getHomeArticlesGroup = (groupId: string): Promise<IResponse> =>
  axios.get(`/home/articles/${groupId}`);

export const useGetHomeArticlesGroup = (
  groupId: string,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['home-articles-group', groupId],
    () => getHomeArticlesGroup(groupId),
    options
  );
